import {
  IOnOrderCreatedParams,
  StorefrontPlugins,
} from '@engyalo/storefront-types';
import { IProduct } from '@engyalo/storefront-types/lib/plugins/model';

function parseJSON<T extends Object>(object: T | string) {
  let parsed = null;
  try {
    parsed = typeof object === 'string' ? JSON.parse(object) : object;
  } catch (error) {
    parsed = null;
  }

  return parsed;
}

export const plugins = {
  Storefront: {
    props: {
      hidePrices: true,
      onOrderCreated({ cart, orderConfig, t }: IOnOrderCreatedParams) {
        const orderSummary = Object.values(cart)
          .map((cartItem: IProduct) => `${cartItem.quantity}x ${cartItem.name}`)
          .join('\n');
        const message = t('cart-orderSummary', { summary: orderSummary });

        const metadata =
          orderConfig.metadata !== null &&
          parseJSON<{ storeNumber?: string }>(orderConfig.metadata);

        if (metadata && metadata.storeNumber) {
          window.location.href = `https://wa.me/${
            metadata.storeNumber
          }/?text=${encodeURIComponent(message)}`;
        }
      },
    },
  },
} as StorefrontPlugins;
